import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogFooter } from '../../../../components/ui/dialog';
import { Button } from '../../../../components/ui/button';
import { Label } from '../../../../components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../../components/ui/select';

export const LinkStagingInvestorDialog = ({
  linkDialog,
  setLinkDialog,
  linkInvestorId,
  setLinkInvestorId,
  investors,
  handleLinkInvestor,
}) => (
  <Dialog open={linkDialog.open} onOpenChange={o => setLinkDialog(p => ({...p, open: o}))}>
    <DialogContent className="max-w-sm">
      <DialogHeader><DialogTitle>Link Investor</DialogTitle><DialogDescription>Manually match RiskParticipant "{linkDialog.item?.risk_participant}" to an investor account</DialogDescription></DialogHeader>
      <div className="py-4">
        <Label>Select Investor</Label>
        <Select value={linkInvestorId} onValueChange={setLinkInvestorId}>
          <SelectTrigger><SelectValue placeholder="Select investor" /></SelectTrigger>
          <SelectContent>{investors.map(inv => <SelectItem key={inv.id} value={inv.id}>{inv.first_name} {inv.last_name} ({inv.email})</SelectItem>)}</SelectContent>
        </Select>
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={() => setLinkDialog({open:false,item:null})}>Cancel</Button>
        <Button onClick={handleLinkInvestor} disabled={!linkInvestorId} className="bg-amber-500 hover:bg-amber-600 text-slate-900">Link</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
